import { PrintUtils } from '@/utils/PrintUtils'
import DateUtils from '@/utils/dateUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import * as BillingConstants from '@/class/cargo/model/parameters/BillingConstants'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import { EstimateProfitUtil } from '@/class/cargo/model/utils/EstimateProfitUtil'
import { CreditControlUtil } from '@/class/cargo/model/utils/CreditControlUtil'
import { EntityDefaultValueUtil } from '@/class/cargo/model/utils/EntityDefaultValueUtil'
import { StimulSoftUtil } from '@/class/cargo/model/utils/StimulSoftUtil'
import { PrintTemplateManager } from '@/class/cargo/model/utils/PrintTemplateManager'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { IntegratedJob } from '@/class/model/booking/IntegratedJob'
import { getUserDefaultDepartment } from '@/api/user'
import { shutOut, canBatchShutout, printProfit, calculateProfit, getChargeIsInvoice, commit, saveJobInfo } from '@/api/seaExport/seaExportJob'
import { getDocumentType } from '@/api/documentType'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import { backReturn } from '@/api/booking/job'
import StrUtils from '@/utils/StrUtils'
import { canCreateByCreditInfoDetail } from '@/api/partner/creditInfo'
import * as SeaExportConstants from '@/class/cargo/model/parameters/ContainerLoadType'

export class BookingWorkspacePM {
  /**
  * @param {Object} view 视图
  */
  constructor(view) {
    this.view = view
    this.$refs = view.$refs
    this.$nextTick = view.$nextTick
    this.$message = view.$message
    this.$confirm = view.$confirm
    this.$checkPermission = view.$checkPermission
    this.chargeAccountIdObject = null
    this._defalutOpDepartmentMap = new Map()
  }
  get optName() {
    return this.view.optName
  }
  set optName(optName) {
    this.view.optName = optName
  }
  get context() {
    return this.view.context
  }
  set context(context) {
    this.view.context = context
  }
  get office() {
    return this.context.office
  }
  set office(office) {
    this.context.office = office
  }
  get config() {
    return this.context.config
  }
  set config(config) {
    this.context.config = config
  }
  get currentRow() {
    return this.view.currentRow
  }
  set currentRow(currentRow) {
    this.view.currentRow = currentRow
  }
  get paramsOfTab() {
    return this.view.paramsOfTab
  }
  set paramsOfTab(paramsOfTab) {
    this.view.paramsOfTab = paramsOfTab
  }
  get activeTabName() {
    return this.view.activeTabName
  }
  set activeTabName(activeTabName) {
    this.view.activeTabName = activeTabName
  }
  get btnInfo() {
    return this.view.btnInfo
  }
  set btnInfo(btnInfo) {
    this.view.btnInfo = btnInfo
  }
  get shutOutDialog() {
    return this.view.shutOutDialog
  }
  set shutOutDialog(shutOutDialog) {
    this.view.shutOutDialog = shutOutDialog
  }
  get templateSelectorDialog() {
    return this.view.templateSelectorDialog
  }
  set templateSelectorDialog(templateSelectorDialog) {
    this.view.templateSelectorDialog = templateSelectorDialog
  }
  get checkingWindow() {
    return this.view.checkingWindow
  }
  get checkingSaveJobWindow() {
    return this.view.checkingSaveJobWindow
  }
  set checkingWindow(checkingWindow) {
    this.view.checkingWindow = checkingWindow
  }
  async getDefaultJob() {
    const entityDefValUtil = EntityDefaultValueUtil.getInstance()
    if (!entityDefValUtil.defaultValues) {
      await entityDefValUtil.initEntityDefaultValue()
    }
    return entityDefValUtil.integratedJob.getData()
  }
  async getOpDepartment(officeId) {
    let opDepartment = this._defalutOpDepartmentMap.get(officeId)
    if (!opDepartment) {
      opDepartment = await getUserDefaultDepartment({ category: 'role', shape: 'op', userId: 0, officeId }).then(res => res.data)
      this._defalutOpDepartmentMap.set(officeId, opDepartment)
    }
    return opDepartment
  }
  returnReview() {
    if (!this.currentRow) {
      return
    }
    JobUtils.batchReturnReview(this.view, [this.currentRow])
  }
  // 退关
  toShutOut() {
    const item = this.currentRow
    const jobKeys = [item.uuid]
    this.shutOutDialog.jobKeys = jobKeys
    // 财务审核
    if (item.jobState === 2) {
      this.$message.warning(this.view.$t('Message.HaveBusinessHasBeenSubmittedCannotBeShutOut'))
      return
    }
    // 退关
    if (item.shutOut) {
      if (!this.view.integratedLogisticsType) {
        if (!this.$checkPermission(['button_IEBooking_cancelShutout'])) {
          this.$message.warning(this.view.$t('Message.NoPermissionToCancelTheShutOut'))
          return
        }
      } else if (this.view.integratedLogisticsType && this.view.integratedLogisticsType === SeaExportConstants.STUFFY_TT.code) {
        if (!this.$checkPermission(['button_TTIEBooking_cancelShutout'])) {
          this.$message.warning(this.view.$t('Message.NoPermissionToCancelTheShutOut'))
          return
        }
      } else if (this.view.integratedLogisticsType && this.view.integratedLogisticsType === SeaExportConstants.STUFFY_CL.code) {
        if (!this.$checkPermission(['button_CLIEBooking_cancelShutout'])) {
          this.$message.warning(this.view.$t('Message.NoPermissionToCancelTheShutOut'))
          return
        }
      } else if (this.view.integratedLogisticsType && this.view.integratedLogisticsType === SeaExportConstants.STUFFY_IC.code) {
        if (!this.$checkPermission(['button_ICIEBooking_cancelShutout'])) {
          this.$message.warning(this.view.$t('Message.NoPermissionToCancelTheShutOut'))
          return
        }
      } else {
        if (!this.$checkPermission(['button_IEBooking_cancelShutout'])) {
          this.$message.warning(this.view.$t('Message.NoPermissionToCancelTheShutOut'))
          return
        }
      }
      // 取消退关
      this.$confirm(this.view.$t('Message.ConfirmToCancelTheShutOut'), this.view.$t('common.tips.prompt'), {
        confirmButtonText: this.view.$t('constant.yes'),
        cancelButtonText: this.view.$t('constant.no'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        this.btnInfo.operateNameCode = Number(SystemConstants.OPERATE_CANCEL_SHUTOUT.code)
        shutOut({ anyStr: item.uuid }).then(res => this.shutOutResult(res))
      }).catch(() => { })
    } else {
      canBatchShutout({ jobKeys }).then(res => this.canBatchShutoutResult(res))
    }
  }
  // 退关弹框处理
  canBatchShutoutResult(res) {
    const result = Number(res.data)
    this.shutOutDialog.shutOutButtonShow2 = ''
    if (result === 0) {
      this.shutOutDialog.shutOutTip1 = this.view.$t('SeaExport.CustomsClearanceChargeRelatedEdit')
      this.shutOutDialog.shutOutTip2 = this.view.$t('SeaExport.CustomsClearanceNoChargeNoChange')
    } else if (result === 1) {
      this.shutOutDialog.shutOutTip1 = this.view.$t('SeaExport.CustomsClearanceChargeRelatedEdit')
      this.shutOutDialog.shutOutTip2 = this.view.$t('SeaExport.ClearFeeNoChargeCustomsClearance')

      this.shutOutDialog.shutOutButtonShow2 = 'none'
    } else if (result === 2) {
      this.$message.warning(this.view.$t('Message.PleaseRemoveThisTicketFromMblThenShutOutBatch'))
    } else if (result === 3) {
      this.$message.warning(this.view.$t('Message.PleaseRemoveAllTicketsFromMblThenShutOutBatch'))
    }
    if (result === 0 || result === 1) {
      this.shutOutDialog.visible = true
    }
  }
  // 有费用退关
  hasChargeShutoutHandler() {
    this.shutOutDialog.hasCharge = true
    this.btnInfo.operateNameCode = Number(SystemConstants.OPERATE_SHUTOUT.code)
    shutOut({ anyStr: this.currentRow.uuid, anyBool: true }).then(res => this.shutOutResult(res))
  }
  // 无费用退关
  async noHasChargeShutoutHandler() {
    const job = this.currentRow
    this.shutOutDialog.hasCharge = false
    this.btnInfo.operateNameCode = Number(SystemConstants.OPERATE_SHUTOUT.code)
    const loading = getLoading4Cxt(this)
    try {
      const body = { job: { ...job }}
      delete body.job.containerUsages
      delete body.job.containers
      const result = await JobUtils.checkBySaveJobNode(body, job.lob, CheckRuleConstants.NO_FEE_REFUND.code)
      if (result.needShowDialog) {
        loading.close()
        const callBack = async() => { shutOut({ anyStr: this.currentRow.uuid, anyBool: false }).then(res => this.shutOutResult(res)) }
        this.checkingSaveJobWindow.checkNode = CheckRuleConstants.NO_FEE_REFUND.code
        this.checkingSaveJobWindow.rowData = result.rowData
        this.checkingSaveJobWindow.callBack = callBack
        this.checkingSaveJobWindow.visible = true
      } else {
        shutOut({ anyStr: this.currentRow.uuid, anyBool: false }).then(res => this.shutOutResult(res))
      }
    } catch (err) {
      throw err
    } finally {
      loading.close()
    }
  }
  // 退关结果处理
  shutOutResult(res) {
    // const j = res.data
    // if (!j) return
    // const msg = j.shutOut ? this.view.$t('Message.ShutOutSuccessfully') : this.view.$t('Message.CancelShutOutSuccessfully')
    // this.$confirm(msg, this.view.$t('common.tips.prompt'), {
    //   confirmButtonText: this.view.$t('common.btn.ok'),
    //   showCancelButton: false,
    //   closeOnClickModal: false,
    //   showClose: false,
    //   center: true,
    //   type: 'success'
    // }).then(() => {
    //   if (this.btnInfo.operateNameCode === Number(SystemConstants.OPERATE_CANCEL_SHUTOUT.code)) {
    //     this.currentRow.jobState = SystemConstants.OPERATING
    //     this.currentRow.shutOut = false
    //   } else {
    //     const hasCharge = this.shutOutDialog.hasCharge
    //     this.currentRow.shutOut = true
    //     if (!hasCharge) {
    //       this.currentRow.jobState = SystemConstants.SHUT_OUT
    //     }
    //   }
    //   this.view.reset([this.currentRow])
    //   this.view.saveJobNos.push(this.currentRow)
    //   this.view.againShow()
    // })
    // this.shutOutDialog.visible = false
    // CARGO-32950 退关后，弹框要改为提示
    const j = res.data
    if (!j) return
    if (j.shutOut) {
      this.$message.success(this.view.$t('Message.ShutOutSuccessfully'))
    } else {
      this.$message.success(this.view.$t('Message.CancelShutOutSuccessfully'))
    }
    if (this.btnInfo.operateNameCode === Number(SystemConstants.OPERATE_CANCEL_SHUTOUT.code)) {
      this.currentRow.jobState = SystemConstants.OPERATING
      this.currentRow.shutOut = false
    } else {
      const hasCharge = this.shutOutDialog.hasCharge
      this.currentRow.shutOut = true
      if (!hasCharge) {
        this.currentRow.jobState = SystemConstants.SHUT_OUT
      }
    }
    this.view.reset([this.currentRow])
    this.view.saveJobNos.push(this.currentRow)
    this.view.againShow()
    this.shutOutDialog.visible = false
  }
  // 打印
  onPrint() {
    const job = this.currentRow
    if (JobUtils.isBlockJob(job)) {
      this.$message.warning(job.jobNo + '已被锁定,不能打印,请联系上级主管解锁!')
      return
    }
    this.$nextTick(async() => {
      // 每个页签的参数
      const params = await this.$refs[this.activeTabName].getPrintData() || null
      if (!params) return
      // 公共参数
      if (!Object.prototype.hasOwnProperty.call(params, 'jobuuid') || !params.jobuuid) {
        params.jobuuid = job.uuid
      }
      if (!Object.prototype.hasOwnProperty.call(params, 'JOB_UUID') || !params.JOB_UUID) {
        params.JOB_UUID = job.uuid
      }
      console.log('---params--', params)
      this.templateSelectorDialog.ctx = Object.prototype.hasOwnProperty.call(params, 'ctx') ? params.ctx : null
      if (Object.prototype.hasOwnProperty(params, 'ctx')) delete params.ctx
      this.templateSelectorDialog.category = params.category
      this.templateSelectorDialog.data = params
      // 组装打印回调函数
      this.onPrintCallback(params)
      this.templateSelectorDialog.visible = true
    })
  }
  // 组装打印回调函数 优先取 params 里面的回调，再取页签中的回调，这样修改是为了满足国外账单的特殊情况
  onPrintCallback(params) {
    if (Object.prototype.hasOwnProperty.call(params, 'prePrintCallback')) {
      this.view.prePrintCallback = params.prePrintCallback
      delete params.prePrintCallback
    } else {
      if (this.$refs[this.activeTabName].prePrintCallback) {
        this.view.prePrintCallback = event => this.$refs[this.activeTabName].prePrintCallback(event)
      } else {
        this.view.prePrintCallback = null
      }
    }
    if (Object.prototype.hasOwnProperty.call(params, 'printedCallback')) {
      this.view.printedCallback = params.printedCallback
      delete params.printedCallback
    } else {
      if (this.$refs[this.activeTabName].printedCallback) {
        this.view.printedCallback = event => this.$refs[this.activeTabName].printedCallback(event)
      } else {
        this.view.printedCallback = null
      }
    }
    if (Object.prototype.hasOwnProperty.call(params, 'v2CheckCallback')) {
      this.view.v2CheckCallback = params.v2CheckCallback
      delete params.v2CheckCallback
    } else {
      if (this.$refs[this.activeTabName].v2CheckCallback) {
        this.view.v2CheckCallback = (isSure, template, entity, arms) => this.$refs[this.activeTabName].v2CheckCallback(isSure, template, entity, arms)
      } else {
        this.view.v2CheckCallback = null
      }
    }
  }
  // 合并当前job【刷新当前job】
  async mergeCurrentRow(res) {
    if (res && res.data) {
      for (const key in res.data) {
        if (typeof this.currentRow[key] === 'object') {
          continue
        }
        this.currentRow[key] = res.data[key]
      }
      if (this.currentRow.masterFlag) {
        this.currentRow.lclSlaves = ''
        await new IntegratedJob(this.currentRow).getLclSlaves()
      }
      this.view.saveJobNos.push(this.currentRow)
      this.view.isRefresh = true
    }
  }
  // 打印提示
  async printAlert(isProfitPrint = false) {
    const job = this.currentRow
    const printProfitToPreCommit = Number(this.config.get('PrintProfitToPreCommit'))
    if (printProfitToPreCommit === 0 || job.jobState === SystemConstants.SHUT_OUT || job.jobState === SystemConstants.VERIFIED ||
      job.jobState === SystemConstants.COMMITED || (job.jobState === SystemConstants.PRE_COMMIT && printProfitToPreCommit === 1)) {
      this.onConfirmedPrintProfit(isProfitPrint)
    } else {
      let msg = this.view.$t('Message.VerifyThatTheRelatedFileHasBeenUploadedBeforeSubmittingSystemContinue')
      if (this.btnInfo.isPreCommit) {
        msg = this.view.$t('Message.SubmittedToTheSuperiorAuditVerifyThatTheRelatedFileHasBeenUploadedBeforeSubmittingSystemContinue')
      }
      await this.$confirm(msg, this.view.$t('common.tips.warning'), {
        confirmButtonText: this.view.$t('common.btn.ok'),
        cancelButtonText: this.view.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        this.onConfirmedPrintProfit(isProfitPrint, true)
      }).catch({})
    }
  }
  onConfirmedPrintProfit(isProfitPrint = false, isPrint = false) {
    // 利润打印 按钮逻辑
    // if (isProfitPrint) {
    //   calculateProfit(this.currentRow.uuid, this.btnInfo.operateNameCode, this.btnInfo.isPrintOpr, true, this.btnInfo.isPreCommit, this.office.officeId, this.optName).then(res => this.calculateProfit2ResultHandler(res, isProfitPrint, isPrint))
    //   return
    // }
    if (Number(this.config.get('useCheckRule')) === 1) {
      printProfit(this.currentRow.uuid, this.btnInfo.operateNameCode, this.office.officeId, this.optName).then(res => this.calculateProfit2ResultHandler(res, isProfitPrint, isPrint))
    } else {
      calculateProfit(this.currentRow.uuid, this.btnInfo.operateNameCode, this.btnInfo.isPrintOpr, true, this.btnInfo.isPreCommit, this.office.officeId, this.optName).then(res => this.calculateProfit2ResultHandler(res, isProfitPrint, isPrint))
    }
  }
  async calculateProfit2ResultHandler(res, isProfitPrint = false, isPrint = false) {
    const oldJobState = this.currentRow.jobState
    await this.mergeCurrentRow(res)
    if ((!isProfitPrint || isPrint) && this.btnInfo.printEvent && !PrintUtils.isPrint(this.btnInfo.printEvent.action)) {
      const template = this.btnInfo.printEvent.template
      const parameter = this.btnInfo.printEvent.parameter
      let documentType = null
      if (template && template.documentTypeUuid || !Object.prototype.hasOwnProperty.call(parameter, 'documentType') || !parameter.documentType) {
        await getDocumentType(template.documentTypeUuid).then(res => {
          documentType = res.data ? res.data : null
        })
      }
      if (StimulSoftUtil.isOpenStiReport(template)) {
        parameter.designMode = this.$checkPermission(['role_template_design']) ? 1 : 0
        parameter.documentType = documentType
        await StimulSoftUtil.stiReportPreview(template, this.currentRow, parameter)
      } else {
        const action = this.btnInfo.printEvent.action || ''
        const format = this.btnInfo.printEvent.format || ''
        const url = await PrintTemplateManager.print(template, documentType, format, parameter, action === PrintUtils.PRINT)
        if (url) {
          await this.loadMailURL(url, parameter)
        }
      }
    }
    this.btnInfo.isPrint = true
    this.btnInfo.isPrintOpr = false
    this.view.againShow()
    if (isProfitPrint && oldJobState === SystemConstants.COMMITED) return // 如果是已提交状态再整箱利润打印，就不需要再弹出提交成功提示
    if (isProfitPrint && Number(this.config.get('PrintProfitToPreCommit')) === 0) return // 如果是打印按钮事件 且printProfitToPreCommit=0，不再弹出提交成功提示
    if (isProfitPrint && oldJobState === SystemConstants.PRE_COMMIT) return
    this.$message.success(this.view.$t('Message.CommitSuccessfully'))
  }
  // 加载MailURLRequest
  async loadMailURL(url, parameter) {
    let status = -1
    const request = new XMLHttpRequest()
    request.open('GET', url, false) // false 同步，默认异步【此处需要同步，需要拿status判断做后续处理】
    request.onload = function(e) {
      status = e.target.status
    }
    request.send()
    if (Object.prototype.hasOwnProperty.call(parameter, 'showPreview') && parameter.showPreview) {
      this.httpResultEmail(status)
    }
  }
  // Mail异常结果处理
  httpResultEmail(status) {
    // 附件过大
    if (status === 0) {
      this.$message.error('附件内容过大')
    } else if (status === 1) {
      this.$message.error(this.view.$t('SeaExport.SmtpServerError'))
    } else if (status === 2) {
      this.$message.error(this.view.$t('SeaExport.NotConnectSmtpServer'))
    } else if (status === 3) {
      this.$message.error(this.view.$t('SeaExport.NotFindFile'))
    } else if (status === 4) {
      this.$message.error(this.view.$t('SeaExport.SendFileError'))
    } else if (status === 5) {
      this.$message.error(this.view.$t('SeaExport.AttachTemplateError'))
    } else if (status === 200) {
      this.$message.success(this.view.$t('SeaExport.MailSentSuccess'))
    }
  }
  // 打印回调函数
  doPrintPROFIT_V2(isSure, template, entity, arms) {
    if (isSure && arms) {
      this.btnInfo.isPreCommit = arms.event.isPreCommit
      if (PrintUtils.isExecutor(arms.event.action)) {
        this.printAlert(true)
      }
    }
  }
  // 验证规则配置公用
  async checkingManager(checkNode, callBack, callBack2) {
    this.checkingWindow.checkNode = checkNode
    this.checkingWindow.callBack = callBack
    this.checkingWindow.callBack2 = callBack2
    this.checkingWindow.visible = true
  }
  // 整箱利润打印提交  isProfitPrint:是否由整箱/拼箱利润打印按钮触发
  doPrintFCLPROFIT(isProfitPrint = false) {
    // 当是整/拼箱利润打印按钮事件且 PrintProfitToPreCommit=1、2 时，先打印再提交
    if (isProfitPrint && [1, 2].includes(Number(this.config.get('PrintProfitToPreCommit')))) {
      this.previewProfit({ data: this.currentRow })
    } else {
      calculateProfit(this.currentRow.uuid, -1, this.btnInfo.isPrintOpr, this.btnInfo.allSubmitFcl, this.btnInfo.isPreCommit, this.office.officeId).then(res => this.previewProfit(res))
    }
  }
  // 预览打印【区分整箱拼箱】
  async previewProfit(res) {
    await this.mergeCurrentRow(res)
    // 预提交/提交直接显示已提交，不显示利润打印弹窗
    if (Number(this.view.context.config.get('useCheckRule')) === 1) {
      printProfit(this.view.currentRow.uuid, this.view.btnInfo.operateNameCode, this.view.office.officeId, this.view.optName).then(res => this.calculateResultHandler(res))
    } else {
      calculateProfit(this.view.currentRow.uuid, this.view.btnInfo.operateNameCode, this.view.btnInfo.isPrintOpr, true, this.view.btnInfo.isPreCommit, this.view.office.officeId, this.view.optName).then(res => this.calculateResultHandler(res))
    }
    this.view.againShow()
  }
  async calculateResultHandler(res) {
    this.view.optName = ''
    const oldJobState = this.view.currentRow.jobState
    await this.mergeCurrentRow(res)
    this.view.againShow()
    if (oldJobState === SystemConstants.COMMITED) return // 如果是已提交状态再整箱利润打印，就不需要再弹出提交成功提示
    this.view.$message.success(this.view.$t('Message.CommitSuccessfully'))
  }
  // 打印回调函数
  doPrintPROFIT(event) {
    const job = this.currentRow
    this.btnInfo.printEvent = event
    this.btnInfo.isPreCommit = event.isPreCommit
    if (PrintUtils.isExecutor(event.action)) {
      if (job.uuid) {
        // 检查是否有收费用未开发票
        if (job.jobState === SystemConstants.OPERATING) {
          getChargeIsInvoice(job.uuid).then(res => this.getChargeIsInvoiceResult(res, true))
        } else {
          this.printAlert(true)
        }
      }
    }
  }
  // 检查是否有收费用未开发票
  async getChargeIsInvoiceResult(res, isProfitPrint = false) {
    const flag = res.data
    if (flag) {
      const msg = this.btnInfo.isPrint ? this.view.$t('Message.ThereAreFeesReceivableNotInvoicedPrint') : this.view.$t('Message.ThereAreFeesReceivableNotInvoicedSubmit')
      await this.$confirm(msg, this.view.$t('common.tips.prompt'), {
        confirmButtonText: this.view.$t('common.btn.ok'),
        cancelButtonText: this.view.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'info'
      }).then(async() => {
        await this.printAlert(isProfitPrint)
      }).catch(() => {
        this.btnInfo.isPrint = true
      })
    } else {
      await this.printAlert(isProfitPrint)
    }
  }
  // 确认是否可打印  isProfitPrint 是否由整箱/拼箱利润打印按钮触发
  async checkPrintEnable(callback, isProfitPrint = false) {
    const job = this.currentRow
    const pass = await this.checkOverseaBilling(job)
    if (!pass) {
      const msg3 = this.view.$t('Message.WithCostsAbroadWithoutValidBillingNumberYouCannotPrintAnAnalysisOfProfitTable')
      const msg4 = this.view.$t('Message.WithCostsAbroadWithoutValidBillingNumberCannotBeSubmitted')
      this.$message.warning(this.btnInfo.isPrint ? msg3 : msg4)
      return
    }
    callback(isProfitPrint)
  }
  // 检查费用是否开过账单
  async checkOverseaBilling(job) {
    let pass = true
    const charges = await new IntegratedJob(job).getCharges()
    for (const charge of charges) {
      if (charge.oversea && !charge.paidOff && charge.offsetState <= 0 && (!charge.billingUuid || !charge.billingNo)) {
        pass = false
        break
      }
    }
    return pass
  }
  // 预提交
  doPreSubmit() {
    this.doCommonSubmit(CheckRuleConstants.NODE_PRE_COMMIT.code)
  }
  // 提交
  doSubmit() {
    this.doCommonSubmit(CheckRuleConstants.NODE_COMMIT.code)
  }
  // 主管提交
  doManagerSubmit() {
    this.doCommonSubmit(CheckRuleConstants.NODE_MANAGER_COMMIT.code)
  }
  // 公用提交逻辑【预提交/提交/主管提交】
  async doCommonSubmit(node) {
    this.optName = ''
    const job = this.currentRow
    if (node === CheckRuleConstants.NODE_COMMIT.code || node === CheckRuleConstants.NODE_MANAGER_COMMIT.code) {
      // 预付款余额校验
      const checkFailUuids = []
      const jobKeys = []
      jobKeys.push(job.uuid)
      const continueExec = await JobUtils.checkBalanceBeforeSubmitHandler(jobKeys, checkFailUuids)
      if (!continueExec) {
        return
      }
      // 余额不足
      if (checkFailUuids && checkFailUuids.indexOf(job.uuid) !== -1) {
        return
      }
    }
    this.btnInfo.isPreCommit = node === CheckRuleConstants.NODE_PRE_COMMIT.code
    if (node === CheckRuleConstants.NODE_PRE_COMMIT.code) {
      this.btnInfo.operateNameCode = SystemConstants.OPERATE_PRE_SUBMISSION.code
    } else if (node === CheckRuleConstants.NODE_COMMIT.code) {
      this.btnInfo.operateNameCode = SystemConstants.OPERATE_SUBMISSION.code
    } else if (node === CheckRuleConstants.NODE_MANAGER_COMMIT.code) {
      this.btnInfo.operateNameCode = SystemConstants.OPERATE_MANAGER_SUBMISSION.code
    }
    this.btnInfo.isPrintOpr = false
    const checkApChargeVerify = Number(this.config.get('PreCommitJobCheckApChargeStateVerify'))
    if (this.btnInfo.isPreCommit && checkApChargeVerify === 1) {
      const isPass = await JobUtils.checkChargeStateVerify(job)
      if (!isPass) {
        this.$message.warning(this.view.$t('Message.NotAllFeesAndChargesPayableAuditCannotBeSubmittedInAdvance'))
        return
      }
    }
    // 判断是否开启验证规则
    const useCheckRule = Number(this.config.get('useCheckRule')) === 1
    const hasCheckRule = true
    if (useCheckRule && hasCheckRule) {
      const callBack = () => { this.getDoSubmitCallBack() }
      this.checkingManager(node, callBack, null)
    } else {
      this.doSubmitHandler()
    }
  }
  // 提交【验证规则回调函数】
  getDoSubmitCallBack() {
    const job = this.currentRow
    const checkChargeInvoice = Number(this.config.get('CheckReceivableChargePrintInvoice'))
    if (this.btnInfo.isPreCommit || checkChargeInvoice < 1) {
      commit(job.uuid, this.btnInfo.operateNameCode, this.btnInfo.isPreCommit, this.office.officeId).then(res => this.commitResultHandler(res))
    } else {
      getChargeIsInvoice(job.uuid).then(res => this.getChargeIsInvoiceResult(res))
    }
  }
  // 提交【验证规则回调函数】
  async commitResultHandler(res) {
    await this.mergeCurrentRow(res)
    this.view.againShow()
    this.$message.success(this.view.$t('Message.CommitSuccessfully'))
  }
  // 获取一个只有基本类型属性的对象副本
  getBasicTypeObject(job, ...ignoreFields) {
    const result = { ...job }
    for (const key in result) {
      if (typeof result[key] === 'object') {
        if (ignoreFields.length > 0 && ignoreFields.includes(key)) {
          continue
        }
        delete result[key]
      }
    }
    return result
  }
  // 提交当前记录
  async doSubmitHandler() {
    const job = this.currentRow
    if (job.jobState === SystemConstants.PRE_COMMIT) {
      await this.loadChargeHandler()
      return
    }
    this.btnInfo.isPrint = false
    await this.checkPrintEnable(() => {
      calculateProfit(this.currentRow.uuid, -1, this.btnInfo.isPrintOpr, this.btnInfo.allSubmitFcl, this.btnInfo.isPreCommit, this.office.officeId).then(res => this.previewProfit(res))
    })
  }
  // 加载当前业务的费用
  async loadChargeHandler() {
    const job = this.currentRow
    job.jobState = SystemConstants.COMMITED
    for (const c of job.charges) {
      if (c.chargeState === BillingConstants.CHARGE_STATE_NORMAL.code) {
        c.chargeState = BillingConstants.CHARGE_STATE_SUBMIT.code
      }
      // 刷新汇率
      const localCurrency = RateUtil.localCurrencyByOfficeId(c.branchId)
      c.exchangeRate = await RateUtil.getForeignExchangeRateByJob(localCurrency, c.currency, job, c.branchId)
    }
    job.operateNameCode = this.btnInfo.operateNameCode
    job.submissionDate = DateUtils.formatStandardDateTime(new Date())
    job.commitUser = this.view.context.user.userId
    await saveJobInfo(this.getBasicTypeObject(job, 'charges')).then(async res => {
      await this.mergeCurrentRow(res)
      this.view.againShow()
      this.$message.warning(this.view.$t('Message.CommitSuccessfully'))
    })
  }
  // 主管审核
  async doSubmitAudit_ManagerSubmit() {
    this.optName = ''
    const job = this.currentRow
    const checkApChargeVerify = parseInt(this.config.get('PreCommitJobCheckApChargeStateVerify'))
    if (checkApChargeVerify === 1 && !(await JobUtils.checkChargeStateVerify(job))) {
      this.$message.warning(this.view.$t('Message.NotAllFeesAndChargesPayableAuditCannotBeSubmittedInAdvance'))
      return
    }
    const callBack = () => { this.getDoSubmitAudit_ManagerSubmit() }
    const callBack2 = () => { this.getDoSubmitAudit_ManagerSubmit2() }
    const checkNode = 10
    this.checkingManager(checkNode, callBack, callBack2)
  }
  // 主管审核【验证规则回调函数】
  getDoSubmitAudit_ManagerSubmit() {
    commit(this.currentRow.uuid, SystemConstants.OPERATE_SUBMISSION.code, false, this.office.officeId).then(async res => {
      await this.mergeCurrentRow(res)
      this.view.againShow()
    })
  }
  // 主管审核【验证规则回调函数】
  getDoSubmitAudit_ManagerSubmit2() {
    this.btnInfo.showMessage = false
    this.loadChargesPrintReturnHandler()
  }
  async loadChargesPrintReturnHandler() {
    const job = this.currentRow
    this.refChargeChargeState(job.charges)
    job.jobState = SystemConstants.OPERATING
    job.manageAuditStatus = 0
    job.operateNameCode = this.btnInfo.operateNameCode
    job.sopStateUpdate = 1
    await saveJobInfo(this.getBasicTypeObject(job, 'charges')).then(async res => {
      await this.mergeCurrentRow(res)
      this.view.againShow()
      if (this.btnInfo.showMessage) {
        this.$message.warning(this.view.$t('Message.AlreadyWithdraw'))
      } else {
        this.btnInfo.showMessage = true
      }
    })
  }
  refChargeChargeState(charges) {
    const submitChargeState = parseInt(this.config.get('CommitJobChangedChargeState'))
    if (submitChargeState === 1 && charges && charges.length > 0) {
      for (const c of charges) {
        if (c.chargeState === BillingConstants.CHARGE_STATE_SUBMIT.code) {
          c.chargeState = BillingConstants.CHARGE_STATE_NORMAL.code
        }
      }
    }
  }
  // 退回操作/撤回
  async backReturn() {
    const job = this.currentRow
    if (job.jobState === SystemConstants.COMMITED || job.jobState === SystemConstants.PRE_COMMIT) {
      this.btnInfo.operateNameCode = SystemConstants.OPERATE_PRINT_RETURN.code
      let lb = this.view.$t('Message.Withdraw')
      if (job.jobState === SystemConstants.PRE_COMMIT) {
        this.btnInfo.operateNameCode = SystemConstants.OPERATE_RETURN_ACTION.code
        lb = this.view.$t('Message.ReturnAction')
      }
      const operate = job.jobState === SystemConstants.PRE_COMMIT ? SystemConstants.OPERATE_RETURN_ACTION.code : SystemConstants.OPERATE_PRINT_RETURN.code
      if (!await JobUtils.backCheckJobState([job.uuid], operate, job)) {
        this.view.againShow()
        return
      }
      this.$confirm(this.view.$t('Message.IsConfirm') + lb + '?', this.view.$t('common.tips.prompt'), {
        confirmButtonText: this.view.$t('common.btn.ok'),
        cancelButtonText: this.view.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
        this.loading = getLoading()
        backReturn({ jobUuids: [this.currentRow.uuid], lob: 'IE' }).then(async res => {
          this.loading.close()
          await this.mergeCurrentRow(res)
          this.view.againShow()
          this.$message.success(this.view.$t('Message.AlreadyWithdraw'))
        }).finally(() => {
          this.loading.close()
        })
      }).catch(() => { })
    }
  }
  // 日志记录
  logHandle() {
    if (!this.currentRow.uuid) {
      return
    }
    switch (this.view.logCommand) {
      case this.view.$t('CargoMsg.Cargo_BusinessStatusChangeLog'):
        this.view.businessStatusDialog.visible = true
        break
    }
  }
  /**
   * 在保存前进行校验
   */
  async checkBeforeSave(bodyJob) {
    const job = this.paramsOfTab
    // 中邮委托单位是否黑名单
    const blacklist = await JobUtils.checkBlacklistByCustomerId(job.customerId, !(job.uuid && job.customerId === this.currentRow.customerId))
    if (blacklist) {
      if (!job.uuid || (job.uuid && job.customerId !== this.currentRow.customerId)) {
        return false
      }
    }
    const reqInputCharge = Number(this.config.get('saveCharge')) === 1
    const isBookingFeeMandatoryAppliedGlobally = Number(this.config.get('isBookingFeeMandatoryAppliedGlobally')) === 1
    if (!(job.lclMasterUuid && !job.uuid) && !SecurityUtil.checkSaveCharge(reqInputCharge, job, isBookingFeeMandatoryAppliedGlobally)) {
      return false
    }

    if (((!job.lclMasterUuid && !job.uuid)) && reqInputCharge && !isBookingFeeMandatoryAppliedGlobally) {
      const checkEstimate = await EstimateProfitUtil.checkEstimate(job, params => {
        let resolveRef = null
        const result = new Promise(resolve => {
          resolveRef = resolve
        })
        const dialog = this.view.estimateValidationDialog
        dialog.job = params.job
        dialog.estimateProfitRate = params.estimateProfitRate
        dialog.tatolProfit = params.tatolProfit
        dialog.callback = isSave => {
          resolveRef(isSave)
        }
        dialog.visible = true
        return result
      })
      bodyJob.situation = job.situation
      if (!checkEstimate) {
        return false
      }
    }
    /* **************************************** end **************************************** */

    let flag = await CreditControlUtil.checkCreditBlack(job, !blacklist, this.currentRow)
    if (!flag) {
      return false
    }
    flag = await this.checkSalesChenged()
    if (!flag) {
      return false
    }
    flag = await this.checkOpSales()
    if (!flag) {
      return false
    }
    flag = await this.checkWarehouseRecord()
    if (!flag) {
      return false
    }
    flag = await this.checkChargeAccountId()
    if (!flag) {
      return false
    }

    /* ****************************** 查询warehouseNo字段值是否已存在 begin ****************************** */
    const checkJobFields = {}
    const needConfirmeDuplicateWarehouseNo = Number(this.config.get('needConfirmeDuplicateWarehouseNo')) === 1
    if (needConfirmeDuplicateWarehouseNo && job.warehouseNo) {
      checkJobFields.warehouseNo = job.warehouseNo
    }
    const fieldExistResult = await IntegratedJob.checkJobFieldExist(this.context.office.officeId, job.lob, checkJobFields, job.uuid)
    /* ************************************************** end ************************************************** */

    if (typeof fieldExistResult.warehouseNo !== 'undefined') {
      flag = await this.checkWarehouseNo(fieldExistResult.warehouseNo)
      if (!flag) {
        return false
      }
    }
    // 新增情况下，验证是否填写自定义业务类型
    if (!job.uuid) {
      flag = await JobUtils.checkCustomJobType(job)
      if (!flag) {
        return false
      }
    }
    const needConfirmProjectNo = Number(this.config.get('needConfirmProjectNo')) === 1
    // needConfirmProjectNo【是否要验证项目编号重复】; openProjectConfig【是否开启项目管理】
    if (job.poNo && needConfirmProjectNo && Number(this.config.get('openProjectConfig')) === 0) {
      flag = await JobUtils.isPoNoExist(job.poNo, job.uuid)
      if (!flag) {
        return false
      }
    }
    return flag
  }
  /**
   * 检查销售是否发生变更
   */
  async checkSalesChenged() {
    const job = this.paramsOfTab
    // 手动修改销售时，salesRecord为销售新值，联动修改销售时，此处将salesRecord改为旧值
    if (typeof job.salesRecord === 'undefined') {
      job.salesRecord = this.currentRow.sales
    }
    const norminationJobSaleType = Number(this.config.get('NorminationJobSaleType')) === 1
    if (job.uuid && job.salesRecord !== job.sales && norminationJobSaleType && this.currentRow.sales !== job.sales) {
      return await this.$confirm(this.view.$t('Message.ChangeSelectSales'), this.view.$t('Message.Prompt'), {
        confirmButtonText: this.view.$t('constant.yes'),
        cancelButtonText: this.view.$t('constant.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => true).catch(() => false)
    } else {
      return true
    }
  }
  /**
   * 检查销售和操作是否相同
   */
  async checkOpSales() {
    const job = this.paramsOfTab
    if (String(this.config.get('ToExoSystem')) !== 'SZBM' && job.sales !== 0 && job.sales === job.op) {
      return await this.$confirm(this.view.$t('Message.TheSameSalesAndOperationsConfirmThatYouWantToSave'), this.view.$t('Message.Prompt'), {
        confirmButtonText: this.view.$t('constant.yes'),
        cancelButtonText: this.view.$t('constant.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => true).catch(() => false)
    } else {
      return true
    }
  }
  /**
   * 检查仓库是否清除
   */
  async checkWarehouseRecord() {
    const job = this.paramsOfTab
    if (typeof job.warehouseRecord === 'undefined') {
      job.warehouseRecord = this.currentRow.warehouseCmp || 0
    }
    if (job.uuid && job.warehouseRecord !== job.warehouseCmp && !job.masterFlag) {
      return await this.$confirm(this.view.$t('Message.UpdateWarehouseRecord'), this.view.$t('Message.Prompt'), {
        confirmButtonText: this.view.$t('constant.yes'),
        cancelButtonText: this.view.$t('constant.no'),
        type: 'info',
        closeOnClickModal: false
      }).then(() => true).catch(() => false)
    } else {
      return true
    }
  }
  /**
   * 验证费用结算对象
   */
  async checkChargeAccountId() {
    const job = this.paramsOfTab
    let messageTitle = ''
    let company = null
    if (job.charges && job.charges.length > 0) {
      for (const charge of job.charges) {
        if (charge.accountId > 0) {
          company = this.context.companyList.find(p => p.cmpIdx === charge.accountId)
          if (company && !company.active) {
            if (!this.chargeAccountIdObject || !this.chargeAccountIdObject[company.uuid]) {
              if (company.chineseName) {
                messageTitle = this.view.$t('SeaExport.CostSettlementObjectBlocked').replace('{0}', company.chineseName)
              } else {
                messageTitle = this.view.$t('SeaExport.CostSettlementObjectBlocked').replace('{0}', company.englishName)
              }
              break
            }
          }
        }
      }
    }
    if (messageTitle) {
      return await this.$confirm(messageTitle, this.view.$t('Message.Prompt'), {
        confirmButtonText: this.view.$t('constant.yes'),
        cancelButtonText: this.view.$t('constant.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
        this.chargeAccountIdObject = this.chargeAccountIdObject || {}
        this.chargeAccountIdObject[company.uuid] = company.uuid
        return true
      }).catch(() => false)
    } else {
      return true
    }
  }
  /**
   * 检测WarehouseNo是否重复
   */
  async checkWarehouseNo(isExist) {
    if (isExist) {
      return await this.$confirm(this.view.$t('Message.WHNoRepeatedContinue'), this.view.$t('Message.Prompt'), {
        confirmButtonText: this.view.$t('constant.yes'),
        cancelButtonText: this.view.$t('constant.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => true).catch(() => false)
    }
    return true
  }
}
